export default __webpack_public_path__ + "static/media/R5.eb873eff.JPG";